import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { useState } from "react";
import { useAuth } from "../../contexts/AuthContext";
import { LayoutGrid, UtensilsCrossed, Boxes, Wallet, Users, ScrollText, MessageSquare, Settings, LogOut, Menu, X, ExternalLink, Grid3x3, NotebookPen } from "lucide-react";

const NAV = [
  { to: "/panel/siparisler", label: "Sipariş Panosu", icon: LayoutGrid, roles: ["owner", "waiter"] },
  { to: "/panel/masalar", label: "Masalar & Adisyon", icon: Grid3x3, roles: ["owner", "waiter"] },
  { to: "/panel/menu", label: "Menü Yönetimi", icon: UtensilsCrossed, roles: ["owner"] },
  { to: "/panel/stok", label: "Stok Takibi", icon: Boxes, roles: ["owner", "waiter"] },
  { to: "/panel/finans", label: "Gelir - Gider", icon: Wallet, roles: ["owner"] },
  { to: "/panel/veresiye", label: "Veresiye Defteri", icon: NotebookPen, roles: ["owner"] },
  { to: "/panel/musteriler", label: "Müşteri Onayı", icon: Users, roles: ["owner"] },
  { to: "/panel/loglar", label: "Garson Logları", icon: ScrollText, roles: ["owner"] },
  { to: "/panel/sohbet", label: "Canlı Sohbet", icon: MessageSquare, roles: ["owner"] },
  { to: "/panel/ayarlar", label: "Ayarlar", icon: Settings, roles: ["owner"] },
];

const ROLE_LABEL = { owner: "Kafe Sahibi", waiter: "Garson" };

export default function DashboardLayout() {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  const [open, setOpen] = useState(false);
  const items = NAV.filter((n) => n.roles.includes(user?.role));

  const Sidebar = (
    <aside className="w-64 shrink-0 bg-[#101013] border-r border-[#D4AF37]/15 flex flex-col h-full">
      <div className="p-5 border-b border-[#D4AF37]/15 flex items-center gap-3">
        <img src="/cafein-icon.png" alt="CAFE-İN" className="h-10 w-10 object-contain" />
        <div>
          <div className="font-serif text-xl gold-text leading-none">CAFE-İN</div>
          <div className="text-[10px] font-mono uppercase tracking-widest text-[#E5BF47] mt-1">{ROLE_LABEL[user?.role]}</div>
        </div>
      </div>
      <nav className="flex-1 p-3 space-y-1 overflow-y-auto no-scrollbar">
        {items.map((n) => {
          const Icon = n.icon;
          return (
            <NavLink key={n.to} to={n.to} onClick={() => setOpen(false)} data-testid={`nav-${n.to.split("/").pop()}`}
              className={({ isActive }) => `flex items-center gap-3 px-4 py-3 rounded-xl text-sm transition-colors ${isActive ? "bg-[#D4AF37]/15 text-[#FFE599] border border-[#D4AF37]/30" : "text-zinc-400 hover:text-white hover:bg-white/5"}`}>
              <Icon size={18} /> {n.label}
            </NavLink>
          );
        })}
      </nav>
      <div className="p-3 border-t border-[#D4AF37]/15 space-y-1">
        <a href="/" target="_blank" rel="noreferrer" className="flex items-center gap-3 px-4 py-2.5 rounded-xl text-sm text-zinc-400 hover:text-white hover:bg-white/5" data-testid="view-site-btn"><ExternalLink size={18} /> Siteyi Gör</a>
        <button onClick={() => { logout(); nav("/"); }} className="w-full flex items-center gap-3 px-4 py-2.5 rounded-xl text-sm text-rose-400 hover:bg-rose-500/10" data-testid="dash-logout-btn"><LogOut size={18} /> Çıkış Yap</button>
      </div>
    </aside>
  );

  return (
    <div className="h-screen flex bg-[#0B0B0C] overflow-hidden">
      <div className="hidden lg:block">{Sidebar}</div>

      {open && (
        <div className="lg:hidden fixed inset-0 z-50 flex">
          <div className="absolute inset-0 bg-black/70" onClick={() => setOpen(false)} />
          <div className="relative slide-in-right">{Sidebar}</div>
        </div>
      )}

      <div className="flex-1 flex flex-col min-w-0">
        <header className="lg:hidden glass px-5 py-3 flex items-center justify-between">
          <button onClick={() => setOpen(true)} className="text-[#FFE599]" data-testid="dash-menu-toggle"><Menu size={24} /></button>
          <span className="font-serif text-xl gold-text">CAFE-İN Panel</span>
          <button onClick={() => { logout(); nav("/"); }} className="text-rose-400"><LogOut size={20} /></button>
        </header>
        <main className="flex-1 overflow-y-auto p-5 sm:p-8">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
